import { render, staticRenderFns } from "./CCCombatDialog.vue?vue&type=template&id=2583722b&scoped=true&"
import script from "./CCCombatDialog.vue?vue&type=script&lang=ts&"
export * from "./CCCombatDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CCCombatDialog.vue?vue&type=style&index=0&id=2583722b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583722b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
